/* eslint-disable max-len */

import * as React from 'react';
import { UserConsent } from '@makemydeal/dr-platform-types';
import { renderSelectedTemplate } from './renderSelectedTemplate';
import styled from 'styled-components';

interface TCPATemplatesProps {
    dealerName: string;
    shopperTCPAProvider: string;
    showCreditApplicationDisclaimer: boolean;
    showTCPACheckbox: boolean;
    handleCheckbox: (event: React.ChangeEvent<HTMLInputElement>) => void;
    shopperInfoUserConsent: UserConsent | any;
    showShopperConsentText: boolean;
    creditApplicationDisclaimer: string;
}

const TCPATemplatesUI: React.FC<TCPATemplatesProps> = ({
    shopperTCPAProvider,
    dealerName,
    showCreditApplicationDisclaimer,
    showTCPACheckbox,
    handleCheckbox,
    shopperInfoUserConsent,
    showShopperConsentText,
    creditApplicationDisclaimer
}) => {
    const CreditAppDisclaimerContainer = styled.div`
        font-weight: bold;
        text-decoration: underline;
        text-transform: uppercase;
        margin: 8px 0;
    `;

    const creditAppDisclaimer = showCreditApplicationDisclaimer ? (
        <CreditAppDisclaimerContainer data-testid="credit-app-disclaimer" className="credit-app-disclaimer">
            {creditApplicationDisclaimer}
        </CreditAppDisclaimerContainer>
    ) : null;

    return renderSelectedTemplate({
        dealerName,
        shopperTCPAProvider,
        shopperInfoUserConsent,
        handleCheckbox,
        showTCPACheckbox,
        creditAppDisclaimer,
        showShopperConsentText
    });
};

export default TCPATemplatesUI;
